import React, { Fragment } from 'react';

import { FaCheck } from 'react-icons/fa';

import { MenuItemsData } from 'pages/NewRefuel/providers';

import completed from '../../../assets/completed.svg';
import noselected from '../../../assets/noselected.svg';
import selected from '../../../assets/selected.svg';

import {
  StepContainer,
  Step,
  StepNumber,
  StepTitle,
  ImgSeparator,
} from './styles';

type HEaderStepsProps = {
  steps: MenuItemsData[];
  activeStep: number;
};

const HeaderSteps: React.FC<HEaderStepsProps> = ({ steps, activeStep }) => {
  return (
    <StepContainer>
      {steps.map((step, index) => {
        const isCompleted =
          activeStep > step.step || steps.length === activeStep;
        const isActive = !isCompleted && step.step === activeStep;
        let imgCard;

        if (isCompleted) {
          imgCard = completed;
        } else if (isActive) {
          imgCard = selected;
        } else {
          imgCard = noselected;
        }

        return (
          <Fragment key={step.step}>
            <Step
              isActive={isActive}
              isLast={index === steps.length - 1}
              isComplete={isCompleted}
            >
              <StepNumber isActive={isActive} isComplete={isCompleted}>
                {isCompleted ? <FaCheck color="#0B29FB" /> : step.step}
              </StepNumber>
              <StepTitle isActive={isActive} isComplete={isCompleted}>
                {step.name}
              </StepTitle>
              {index < steps.length - 1 && (
                <ImgSeparator src={imgCard} alt="separador" />
              )}
            </Step>
          </Fragment>
        );
      })}
    </StepContainer>
  );
};

export default HeaderSteps;
